import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import PeopleAccess from './domains/people-access';
import { PermissionsProvider } from './domains/people-access/context';

/**
 * Root component of the People & Access application.
 *
 * Embed-first: the Core Shell owns the BrowserRouter, Auth0Provider and
 * ThemeProvider, and mounts this app at `people-access/*` (opened from the Topbar
 * Settings menu). ToastProvider is mounted here so member / role / group actions can
 * raise toasts in both embedded and standalone modes.
 *
 * @param {object} [props]
 * @param {string} [props.noAccessRedirectPath] Host path a viewer without access is sent to
 *   (the shell home). Defaults to `/`.
 */
const PeopleAccessApp = ({ noAccessRedirectPath }) => {
  const { t, ready } = useTranslation('people-access');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <ToastProvider config={{ position: 'top-right', defaultDuration: 4000 }}>
      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <PermissionsProvider noAccessRedirectPath={noAccessRedirectPath}>
          <PeopleAccess />
        </PermissionsProvider>
      </div>
    </ToastProvider>
  );
};

export default PeopleAccessApp;
